import React, { ReactNode } from 'react';
import styled from 'styled-components';

const TitleContainer = styled.div`
  padding: 16px 0 0 0;
  width: 100%;
`;

const TextContainer = styled.p`
  font-size: 14px;
  line-height: 20px;
  font-weight: 400;
  color: #161d1f;
`;

export const SelectContainers = styled.div<{
  $margin?: string;
  $width?: string;
}>`
  width: 100%;
  margin: ${(props) => props.$margin};

  @media (min-width: 640px) {
    width: ${(props) => props.$width};
  }
`;

export const Container = styled.div`
  display: flex;
  border-bottom: 1px solid #84b1cc;

  > div:nth-child(1) {
    min-width: 201px;
    width: 100%;
  }
  > div:nth-child(3) {
    min-width: 291px;
    width: 100%;
  }

  @media (max-width: 639.9px) {
    padding: 4px 19px 16px 19px;
    flex-direction: column;
    width: 100vw;
    margin-left: -19px;
    gap: 16px;

    > div {
      width: 100%;
    }
  }

  @media (min-width: 640px) and (max-width: 768px) {
    padding: 4px 0 16px 0;
    flex-direction: column;
    gap: 16px;

    > div {
      width: 100%;
    }
  }

  @media (min-width: 769px) and (max-width: 991.9px) {
    padding: 4px 0 16px 0;
    flex-direction: row;
    margin-left: 0;
    gap: 8px;

    > div:nth-child(2) {
      min-width: 212px;
      width: 100%;
    }
  }

  @media (min-width: 992px) and (max-width: 1279.9px) {
    padding: 4px 0 16px 0;
    flex-direction: row;
    margin-left: 0;
    gap: 8px;

    > div:nth-child(2) {
      min-width: 118px;
      width: 100%;
    }
  }

  @media (min-width: 1280px) {
    padding: 4px 0 16px 0;
    flex-direction: row;
    margin-left: 0;
    gap: 8px;

    > div:nth-child(2) {
      min-width: 236px;
      width: 100%;
    }
  }
`;

export function Title({ children }: Readonly<{ children: ReactNode }>) {
  return (
    <TitleContainer>
      <TextContainer>{children}</TextContainer>
    </TitleContainer>
  );
}
